var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMysale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1.2em",
    height: "1.2em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C1E899",
    d: "M7.001 12h3.75c1.172 0 2.272-.4 3.061-1.077a3.43 3.43 0 0 0 1.01-1.423H7a1 1 0 0 1 0-2h7.822a3.43 3.43 0 0 0-1.01-1.423C13.022 5.401 11.923 5 10.751 5H7a1 1 0 1 1 0-2h3.75l.18.002L11 3h7a1 1 0 1 1 0 2h-2.425a5.24 5.24 0 0 1 1.322 2.5H18a1 1 0 1 1 0 2h-1.103c-.236 1.127-.865 2.154-1.783 2.941C13.934 13.452 12.363 14 10.75 14H9.712l6.138 5.24a1 1 0 0 1-1.299 1.52l-8.197-6.997l-.01-.009a.996.996 0 0 1-.207-1.26A1 1 0 0 1 7.001 12"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMysale);
export default __webpack_public_path__ + "static/media/mysale.ff4af1acfb8476807c997c174fa09f19.svg";
export { ForwardRef as ReactComponent };